// API service for backend communication
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

class ApiService {
  async request(endpoint, options = {}) {
    const token = await this.getAuthToken();
    
    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers,
      },
    };

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
      const data = await response.json();

      if (!response.ok) {
        return { error: data.error || data.message || 'Request failed' };
      }

      return { data };
    } catch (error) {
      return { error: error instanceof Error ? error.message : 'Network error' };
    }
  }

  async getAuthToken() {
    // Get Firebase auth token
    const { getAuth } = await import('firebase/auth');
    const auth = getAuth();
    if (auth.currentUser) {
      return await auth.currentUser.getIdToken();
    }
    return null;
  }

  // Stripe payment methods
  async createPaymentIntent(bookingId, amount) {
    return this.request('/stripe/create-payment-intent', {
      method: 'POST',
      body: JSON.stringify({ bookingId, amount }),
    });
  }

  async confirmPayment(paymentIntentId) {
    return this.request('/stripe/confirm-payment', {
      method: 'POST',
      body: JSON.stringify({ paymentIntentId }),
    });
  }

  // Trip methods
  async publishTrip(tripId) {
    return this.request('/trips/publish', {
      method: 'POST',
      body: JSON.stringify({ tripId }),
    });
  }

  // Host onboarding
  async createHostProfile(userId, bio) {
    return this.request('/hosts/create', {
      method: 'POST',
      body: JSON.stringify({ userId, bio }),
    });
  }

  async updateHostVerification(hostId, verified) {
    return this.request('/hosts/verify', {
      method: 'POST',
      body: JSON.stringify({ hostId, verified }),
    });
  }

  // Admin functions
  async setUserRole(userId, role) {
    return this.request('/admin/set-role', {
      method: 'POST',
      body: JSON.stringify({ userId, role }),
    });
  }

  async approveHost(hostId) {
    return this.request('/admin/approve-host', {
      method: 'POST',
      body: JSON.stringify({ hostId }),
    });
  }

  async adminPublishTrip(tripId) {
    return this.request('/admin/publish-trip', {
      method: 'POST',
      body: JSON.stringify({ tripId }),
    });
  }

  async createCustomToken(uid) {
    return this.request('/admin/create-custom-token', {
      method: 'POST',
      body: JSON.stringify({ uid }),
    });
  }
}

export const api = new ApiService();

